import React, { useEffect, useState } from "react";
import { Button, Spinner } from "reactstrap";
import Select from "react-select";

function CandidateSelect({ value, icon }) {
  const [candidateOptions, setCandidateOptions] = useState(null);
  const [selectedCandidates, setSelectedCandidates] = useState(null);

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (base, state) => ({
      ...base,
      // state.isFocused can display different borderColor if you need it
      borderColor: "#fff",
      width: "540px",
      // overwrittes hover style
      "&:hover": {
        borderColor: "#fff",
      },
      backgroundColor: state.isDisabled ? "#EFF2F7" : base.backgroundColor,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "black !important" : provided.color,
    }),
  };

  const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  useEffect(() => {
    if (
      value &&
      Array.isArray(value) &&
      value.length > 0 &&
      !isEmptyObject(value)
    ) {
      const candidates = value.map((candidate) => ({
        label: `${candidate?.candidate?.firstName} ${candidate?.candidate?.lastName}`,
        value: `${candidate.id}`,
      }));
      setCandidateOptions(candidates);
    } else {
      setCandidateOptions([]);
    }
  }, [value]);

  const handleChange = (selected) => {
    setSelectedCandidates(selected);
    if (selected === null || selected === undefined) {
      setSelectedCandidates(null);
    }
  };

  return (
    <div className="d-flex gap-2 align-items-center">
      {icon && (
        <Button
          className="d-flex align-items-center justify-content-center"
          style={{
            height: "30px",
            width: "30px",
            backgroundColor: "#F5F5F5",
            border: "1px solid #A8A8A8",
            color: "#7A7A7A",
          }}
        >
          {icon}
        </Button>
      )}

      <Select
        isClearable
        onChange={handleChange}
        styles={customStyles}
        options={candidateOptions}
        value={selectedCandidates}
        placeholder="Select Tagged Candidates"
        isMulti
      />
    </div>
  );
}

export default CandidateSelect;
